import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [pkg, setPkg] = useState("");
  const [addons, setAddons] = useState([]);

  const toggleAddon = (title, price) =>
    setAddons((a) =>
      a.some((x) => x.title === title) ? a.filter((x) => x.title !== title) : [...a, { title, price }]
    );
  const removeAddon = (title) => setAddons((a) => a.filter((x) => x.title !== title));

  const pkgPrice = parseInt((pkg.match(/\$(\d+)/) || [])[1] || 0, 10);
  const total = pkgPrice + addons.reduce((s, a) => s + (a.price || 0), 0);

  return (
    <BookingContext.Provider value={{ pkg, setPkg, addons, toggleAddon, removeAddon, total }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
